import { useOptionsAndAlternatives } from "./useOptionsAndAlternatives";

export type AlternativeProduct = eXpress.core.IAlternativeProduct & {
	alternativeProductCode: eXpress.AlternativeProductCode;
};

export type AlternativeProductGroup = Omit<
	eXpress.core.IAlternativeProductGroup,
	"alternativeProducts"
> & {
	alternativeProducts: AlternativeProduct[];
};

export const useAlternativeProducts = () => {
	const { data: { alternativeProductsGroups } = {}, ...rest } = useOptionsAndAlternatives();
	return {
		alternativeProductsGroups: alternativeProductsGroups?.map(
			({ alternativeProducts, ...groupProps }) => {
				const group = {
					...groupProps,
					// convert dictionary to an array
					alternativeProducts: alternativeProducts.map(
						(alternativeProductCode, alternativeProduct) => ({
							...alternativeProduct,
							alternativeProductCode,
						}),
					),
				};
				return group;
			},
		),
		...rest,
	};
};
